// extracted by mini-css-extract-plugin
export default {"send_part":"send_send_part__+FSH5","send":"send_send__Nve0T"};